import { useEffect, useState } from 'react';
import useSound from '@mrmartineau/use-sound';
import { QRCodeSVG as QRCode } from 'qrcode.react';
import { humanCardName } from '../utils/cards';
import { GIFT_CARD_DURATION_SECONDS, parseGiftCardToken } from '../utils/storage';
import cashSfx from '../sounds/cash.mp3';

export function GiftCardModal({ isOpen, onClose, giftCardId, card }) {
  const [timeLeft, setTimeLeft] = useState(GIFT_CARD_DURATION_SECONDS);
  const [isExpired, setIsExpired] = useState(false);
  const [playCashSound] = useSound(cashSfx);

  useEffect(() => {
    if (!isOpen || !giftCardId) return;

    const payload = parseGiftCardToken(giftCardId);

    if (!payload) {
      setTimeLeft(0);
      setIsExpired(true);
      return;
    }

    setIsExpired(false);

    const updateTimeLeft = () => {
      const remainingSeconds = Math.max(0, Math.ceil((payload.expiresAt - Date.now()) / 1000));
      setTimeLeft(remainingSeconds);
      setIsExpired(remainingSeconds <= 0);
    };

    updateTimeLeft();

    const interval = setInterval(() => {
      updateTimeLeft();
    }, 1000);

    return () => clearInterval(interval);
  }, [isOpen, giftCardId]);

  useEffect(() => {
    if (isOpen && giftCardId) {
      playCashSound();
    }
  }, [isOpen, giftCardId, playCashSound]);

  if (!isOpen || !giftCardId || !card) return null;

  // Generate QR code link - includes the gift card ID
  const baseUrl = window.location.origin + window.location.pathname;
  const giftCardLink = `${baseUrl}?gift=${giftCardId}`;

  const cardName = humanCardName(card);
  const expirySeconds = GIFT_CARD_DURATION_SECONDS;

  return (
    <div className={`modal gift-card-modal ${isOpen ? 'open' : 'closed'}`}>
      <div className='modal-overlay' onClick={() => !isExpired && onClose?.()}></div>
      <div className={`modal-content gift-card-content ${isExpired ? 'expired' : ''}`}>


        {!isExpired ? (
          <>
            <h2>Gift Card Created!</h2>
            <p className='gift-card-info'>Scan this QR code with a camera app to claim the <strong style={{ display: 'inline-block' }}>{cardName}</strong></p>

            <div
              className='gift-card-qr-container'
            >
              <QRCode
                value={giftCardLink}
                size={256}
                level="H"
                includeMargin={true}
                className='gift-card-qr'
              />
            </div>

            <div className='gift-card-timer'>
              <h2>
                <div className={`timer-display ${timeLeft <= 10 ? 'warning' : ''}`}>
                  {timeLeft}
                </div>
              </h2>
            </div>

            <button onClick={onClose} className='close-btn'>Destroy Early</button>
          </>
        ) : (
          <>
            <div className='expired-container'>
              <h2 className='expired-message'>Gift Card Expired</h2>
              <p className='expired-detail'>This QR code is no longer valid. It expired after {expirySeconds} second{expirySeconds === 1 ? '' : 's'}.</p>
            </div>
            <button onClick={onClose} className='close-btn'>Close</button>
          </>
        )}
      </div>
    </div>
  );
}
